import { Routes, Route, Navigate } from "react-router-dom";

import FinancialServices from "./FinancialServices";

const financialServicesRoutes = [
     {routeName: 'stihealthinsurance' , component: <FinancialServices/>},
     {routeName: 'cvishipment' , component: <FinancialServices/>},
     {routeName: 'motorinsurance' , component: <FinancialServices/>},
     {routeName: 'personalinsurance' , component: <FinancialServices/>},
];

const FinancialServicesRoutes = () => {
    return (
    <Routes>
       {financialServicesRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default FinancialServicesRoutes;